import {useCallback} from 'react';

import {useDispatch} from '../../state/hooks';
import {reloadWorkspaceViewFromServer} from '../../state/workspaces/actions';
import {useWBAgentTurnFinished} from '../chat/turnLifeCycle';

interface WBAgentWorkspaceReloadSliceProps {
  workspaceID: string;
}

export const WBAgentWorkspaceReloadSlice = ({
  workspaceID,
}: WBAgentWorkspaceReloadSliceProps) => {
  const dispatch = useDispatch();

  const reloadWorkspace = useCallback(() => {
    void dispatch(reloadWorkspaceViewFromServer(workspaceID)).catch(error => {
      console.error(
        'Failed to reload workspace after agent turn finished',
        error
      );
    });
  }, [dispatch, workspaceID]);

  useWBAgentTurnFinished(reloadWorkspace);
  return null;
};
